import Htmldia from "./Htmldia";
import Htmlhora from "./Htmlhora";
import React, { useEffect, useState } from 'react';
import { getByLatLon, getAlertByLatLon } from "./services/ClimaServices";
import xmlJs from 'xml-js';
import Modal from 'react-bootstrap/Modal';
import { MapContainer, TileLayer, Popup, Marker, Polygon } from 'react-leaflet';
import { FullscreenControl } from "react-leaflet-fullscreen";
import "react-leaflet-fullscreen/styles.css";

function Main({ coords }) {
    const [clima, setClima] = useState({ "copyright": "Tutiempo Network, S.L", "use": "Se autoriza el uso de estos datos citando a https://www.tutiempo.net como fuente de los mismos.", "information": { "temperature": "\u00baC", "wind": "km/h", "humidity": "%", "pressure": "hPa" }, "web": "https://www.tutiempo.net", "language": "es", "locality": { "name": "Madrid", "url_weather_forecast_15_days": "https://www.tutiempo.net/madrid.html", "url_hourly_forecast": "https://www.tutiempo.net/madrid.html?datos=por-horas", "country": "Espa\u00f1a", "url_country": "https://www.tutiempo.net/espana.html" }, "day1": { "date": "2024-1-16", "temperature_max": 15, "temperature_min": 11, "icon": "7", "text": "Cubierto", "humidity": 86, "wind": 20, "wind_direction": "Suroeste", "icon_wind": "SO", "sunrise": "8:37", "sunset": "18:11", "moonrise": "11:49", "moonset": "----", "moon_phases_icon": "6" }, "day2": { "date": "2024-1-17", "temperature_max": 13, "temperature_min": 10, "icon": "19", "text": "Cubierto con lluvias", "humidity": 84, "wind": 34, "wind_direction": "Suroeste", "icon_wind": "SO", "sunrise": "8:36", "sunset": "18:13", "moonrise": "12:12", "moonset": "00:24", "moon_phases_icon": "7" }, "day3": { "date": "2024-1-18", "temperature_max": 13, "temperature_min": 9, "icon": "7", "text": "Cubierto", "humidity": 83, "wind": 31, "wind_direction": "Suroeste", "icon_wind": "SO", "sunrise": "8:36", "sunset": "18:14", "moonrise": "12:37", "moonset": "01:37", "moon_phases_icon": "8" }, "day4": { "date": "2024-1-19", "temperature_max": 12, "temperature_min": 9, "icon": "19", "text": "Cubierto con probabilidad de lluvia", "humidity": 94, "wind": 33, "wind_direction": "Suroeste", "icon_wind": "SO", "sunrise": "8:35", "sunset": "18:15", "moonrise": "13:05", "moonset": "02:48", "moon_phases_icon": "9" }, "day5": { "date": "2024-1-20", "temperature_max": 11, "temperature_min": 9, "icon": "19", "text": "Cubierto con lluvias", "humidity": 90, "wind": 13, "wind_direction": "Nordeste", "icon_wind": "NE", "sunrise": "8:35", "sunset": "18:16", "moonrise": "13:38", "moonset": "04:00", "moon_phases_icon": "10" }, "day6": { "date": "2024-1-21", "temperature_max": 9, "temperature_min": 2, "icon": "2", "text": "Nubes dispersas", "humidity": 62, "wind": 7, "wind_direction": "Suroeste", "icon_wind": "SO", "sunrise": "8:34", "sunset": "18:17", "moonrise": "14:16", "moonset": "05:10", "moon_phases_icon": "11" }, "day7": { "date": "2024-1-22", "temperature_max": 8, "temperature_min": 0, "icon": "7", "text": "Cubierto", "humidity": 61, "wind": 7, "wind_direction": "Suroeste", "icon_wind": "SO", "sunrise": "8:34", "sunset": "18:18", "moonrise": "15:04", "moonset": "06:15", "moon_phases_icon": "12" }, "hour_hour": { "hour1": { "date": "2024-1-16", "hour_data": "16:00", "temperature": 15, "text": "Cubierto", "humidity": 72, "pressure": 1011, "icon": "7", "wind": 18, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour2": { "date": "2024-1-16", "hour_data": "17:00", "temperature": 14, "text": "Cubierto", "humidity": 65, "pressure": 1010, "icon": "7", "wind": 18, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour3": { "date": "2024-1-16", "hour_data": "18:00", "temperature": 14, "text": "Cubierto", "humidity": 71, "pressure": 1010, "icon": "7", "wind": 17, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour4": { "date": "2024-1-16", "hour_data": "19:00", "temperature": 13, "text": "Cubierto", "humidity": 73, "pressure": 1010, "icon": "7", "wind": 16, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour5": { "date": "2024-1-16", "hour_data": "20:00", "temperature": 13, "text": "Cubierto", "humidity": 72, "pressure": 1010, "icon": "7", "wind": 16, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour6": { "date": "2024-1-16", "hour_data": "21:00", "temperature": 13, "text": "Cubierto con probabilidad de lluvia", "humidity": 65, "pressure": 1011, "icon": "19", "wind": 19, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour7": { "date": "2024-1-16", "hour_data": "22:00", "temperature": 11, "text": "Cubierto con probabilidad de lluvia", "humidity": 80, "pressure": 1010, "icon": "19", "wind": 16, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour8": { "date": "2024-1-16", "hour_data": "23:00", "temperature": 11, "text": "Cubierto con probabilidad de lluvias", "humidity": 87, "pressure": 1010, "icon": "19", "wind": 16, "wind_direction": "Sur", "icon_wind": "S" }, "hour9": { "date": "2024-1-17", "hour_data": "0:00", "temperature": 11, "text": "Cubierto con probabilidad de lluvias", "humidity": 88, "pressure": 1008, "icon": "19", "wind": 20, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour10": { "date": "2024-1-17", "hour_data": "1:00", "temperature": 12, "text": "Muy nuboso con lluvias", "humidity": 87, "pressure": 1008, "icon": "19", "wind": 24, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour11": { "date": "2024-1-17", "hour_data": "2:00", "temperature": 12, "text": "Cubierto con probabilidad de lluvias", "humidity": 85, "pressure": 1007, "icon": "19", "wind": 24, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour12": { "date": "2024-1-17", "hour_data": "3:00", "temperature": 12, "text": "Cubierto con probabilidad de lluvias", "humidity": 84, "pressure": 1007, "icon": "19", "wind": 27, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour13": { "date": "2024-1-17", "hour_data": "4:00", "temperature": 11, "text": "Cubierto con probabilidad de lluvia", "humidity": 83, "pressure": 1006, "icon": "19", "wind": 28, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour14": { "date": "2024-1-17", "hour_data": "5:00", "temperature": 11, "text": "Cubierto con probabilidad de lluvia", "humidity": 87, "pressure": 1005, "icon": "19", "wind": 30, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour15": { "date": "2024-1-17", "hour_data": "6:00", "temperature": 11, "text": "Cubierto con probabilidad de lluvia", "humidity": 89, "pressure": 1005, "icon": "19", "wind": 31, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour16": { "date": "2024-1-17", "hour_data": "7:00", "temperature": 11, "text": "Cubierto con lluvias", "humidity": 89, "pressure": 1004, "icon": "19", "wind": 29, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour17": { "date": "2024-1-17", "hour_data": "8:00", "temperature": 11, "text": "Cubierto con probabilidad de lluvia", "humidity": 89, "pressure": 1004, "icon": "19", "wind": 27, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour18": { "date": "2024-1-17", "hour_data": "9:00", "temperature": 11, "text": "Muy nuboso con lluvias", "humidity": 89, "pressure": 1004, "icon": "19", "wind": 25, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour19": { "date": "2024-1-17", "hour_data": "10:00", "temperature": 11, "text": "Cubierto con lluvias", "humidity": 89, "pressure": 1004, "icon": "19", "wind": 26, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour20": { "date": "2024-1-17", "hour_data": "11:00", "temperature": 12, "text": "Cubierto con probabilidad de lluvias", "humidity": 85, "pressure": 1004, "icon": "19", "wind": 30, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour21": { "date": "2024-1-17", "hour_data": "12:00", "temperature": 12, "text": "Cubierto con probabilidad de lluvias", "humidity": 82, "pressure": 1004, "icon": "19", "wind": 29, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour22": { "date": "2024-1-17", "hour_data": "13:00", "temperature": 12, "text": "Cubierto con probabilidad de lluvias", "humidity": 77, "pressure": 1003, "icon": "19", "wind": 33, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour23": { "date": "2024-1-17", "hour_data": "14:00", "temperature": 12, "text": "Cubierto con probabilidad de lluvias", "humidity": 77, "pressure": 1002, "icon": "19", "wind": 33, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour24": { "date": "2024-1-17", "hour_data": "15:00", "temperature": 13, "text": "Cubierto con lluvias", "humidity": 73, "pressure": 1002, "icon": "19", "wind": 32, "wind_direction": "Suroeste", "icon_wind": "SO" }, "hour25": { "date": "2024-1-17", "hour_data": "16:00", "temperature": 13, "text": "Cubierto", "humidity": 72, "pressure": 1003, "icon": "7", "wind": 34, "wind_direction": "Suroeste", "icon_wind": "SO" } } });
    const [loading, setLoading] = useState(true);
    const pointInPolygon = require('point-in-polygon');
    const [alerta, setAlerta] = useState(null)
    const [errorr, setErrorr] = useState(null)
    const [allAlertas, setAllAlertas] = useState([[]])
    const [multipoly, setMultipoly] = useState([[]])
    //const logo = "https://www.smn.gob.ar/sites/all/themes/smn/img/logo.png"
    //const [poly, setPoly] = useState([])


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    /*  var lista =  [[-64.4300000, -30.4100000],[-64.9900000, -30.5000000],[-64.9200000, -30.8200000],[ -64.6600000, -31.0400000],
        [ -63.9300000, -31.1900000],
         [-63.7700000, -30.6300000],
         [-64.2100000, -30.5500000]];
 
    const [xmlData, setXmlData] = useState({
         "_text": "-32.02 -64.25 -32.21 -63.31 -32.80 -62.61 -32.70 -63.76 -32.45 -63.75 -32.28 -64.32"
     });*/

    /*const p = [[-34.26,
    -59.19

    ],
    [-34.21,
    -58.93

    ],
    [-34.3,
    -58.59,

    ],
    [-34.34,
    -58.5,

    ],
    [-34.43,
    -58.58,

    ],
    [-34.4,
    -59.14

    ]
    ]
    const multiPolyline = [
        [
            [-34.26,
            -59.19

            ],
            [-34.21,
            -58.93

            ],
            [-34.3,
            -58.59,

            ],
            [-34.34,
            -58.5,

            ],
            [-34.43,
            -58.58,

            ],
            [-34.4,
            -59.14

            ]
        ],
        [
            [
                -60.57,
                -32.91
            ],
            [
                -59.91,
                -32.86
            ],
            [
                -58.71,
                -33.39
            ],
            [
                -58.8,
                -33.87
            ],
            [
                -59.58,
                -33.59
            ],
            [
                -60.08,
                -33.36
            ]
        ],
        [
            [
                -62.57,
                -31.86
            ],
            [
                -62.15,
                -31.63
            ],
            [
                -61.03,
                -31.71
            ],
            [
                -61.07,
                -32.34
            ],
            [
                -62.09,
                -32.26
            ],
            [
                -62.32,
                -31.98
            ]
        ],
        [
            [
                -62.84,
                -31.72
            ],
            [
                -62.31,
                -31.98
            ],
            [
                -61.91,
                -32.57
            ],
            [
                -62.45,
                -32.93
            ],
            [
                -63.31,
                -32.21
            ]
        ],
        [
            [
                -62.46,
                -32.94
            ],
            [
                -61.94,
                -33.3
            ],
            [
                -60.73,
                -33.5
            ],
            [
                -60.31,
                -33.26
            ],
            [
                -61.49,
                -32.51
            ],
            [
                -61.91,
                -32.57
            ]
        ],
        [
            [
                -63.076171,
                -32.342207
            ],
            [
                -59.3481445,
                -29.7894222
            ],
            [
                -59.5751962,
                -32.2744592
            ]
        ]
    ]*/
    const redOptions = { color: 'red' }

    useEffect(
        () => {
            getByLatLon(coords.latitude, coords.longitude)
                //fetch("https://api.tutiempo.net/json/?lan=es&apid=qwEXaz44a4a4xN4&ll="+ coords.latitude + "," + coords.longitude)//40.4178,-3.7022")
                //.then((res) => res)
                .then((data) => {
                    //console.log("d a t a :> ", data)
                    setLoading(false)
                    setClima(data.data)
                })
                .catch((e) => {
                    console.log('ERROR getByLatLon ', e)
                });

        }, [coords]);

    //const audio = new Audio("/bbc_thunder---_07005230.mp3")

    const start = () => {
        // const audio = this.audioPlayer.nativeElement;
        //audio.play()
    }


    useEffect(
        () => {

            //var list = []
            /*fetch("https://meridianodigital.com.ar/avisocorto_GeoRSS.xml", {
     mode: 'no-cors',
     method: 'GET',
     headers: new Headers({
         'Accept': 'application/xml',
         'content-type': 'application/x-www-form-urlencoded',
         'Access-Control-Allow-Origin': '*',
         'Access-Control-Allow-Methods': 'GET, POST, PUT',
         'Access-Control-Allow-Headers': 'Content-Type',
     })
 })*///40.4178,-3.7022")

            getAlertByLatLon()
            .then(xmlText => {
                    const result = xmlJs.xml2json(xmlText.data, { compact: true, spaces: 4 })

                    // console.log('xmlText:', xmlText.data.replace("\ufeff<?xml", "<?xml"))

                    const item = (JSON.parse(result).rss.channel).item
                    //if (jsonData)
                    //setXmlData(JSON.parse(jsonData));
                    // console.log('xmldata ', xmlData.rss.channel.item[0]["georss:polygon"])
                    // ).then(res => JSON.parse(res).rss.channel//.item[0]["georss:polygon"]
                    // return res.item[0]["georss:polygon"]
                    // )
                    //.then(text =>(text.item[0]["georss:polygon"]._text).split(' ').map(Number))
                    // .then(texto => {
                    //    console.log('xmlData ', texto)
                    var listMulti = []
                    var listAll = []
                    //  for (var key in data) {
                    //  var texto = data[key]
                    //console.log('texto ', texto.item)

                    // if (list[inde] === undefined)
                    // list[index] = []
                    // console.log('length ', texto.item.length)
                    if (item['description']) {
                        console.log("Only one ", item)
                        const val1 = item["description"]._cdata
                        //var val
                        if (item["georss:polygon"]) {
                           const val = item["georss:polygon"]._text.split(' ').map(Number)
                            const list1 = []
                            const list2 = []
                            // var inde = 0;
                            //var index = Math.floor(i / 2);
                            for (var x = 0; x < val.length; x++) {
                                const valo = val[x];
                                //var index = i;
                                const index = Math.floor(x / 2);


                                if (list1[index] === undefined)
                                    list1[index] = [];
                                if (list2[index] === undefined)
                                    list2[index] = [];
                                list1[index].unshift(valo);
                                list2[index].push(valo)

                                console.log('list1 ', JSON.stringify(list2))

                            }
                            // console.log('item ', JSON.stringify(val["georss:polygon"]))
                            // console.log('item1 ', JSON.stringify(val["georss:polygon"]._text))

                            if (pointInPolygon([coords.longitude, coords.latitude], list1)) {
                                //console.log('poly ', new Array(JSON.stringify(val["georss:polygon"]._text)))
                                // console.log('texto.item[i]',texto.item[i]["description"])
                                setAlerta(val1)
                                setShow(true)
                                start()
                                //return  
                            }
                            // if (listMulti[i] === undefined)
                            if (!Array.isArray(listMulti[i]) || !listMulti[i].length)
                                listMulti[0] = [];
                            listMulti[0].push(list2)
                        }
                        //if (listAll[i] === undefined)
                        //if (!Array.isArray(listAll[i]) || !listAll[i].length)
                        //listAll[0] = [];
                        // list[inde].unshift(list1)
                        /*if (!Array.isArray(listMulti) || !listMulti.length)
                        if (!Array.isArray(listAll) || !listAll.length)*/

                        listAll.push(val1)
                        // inde++;
                        //  console.log('lista ', JSON.stringify(list))
                        console.log('val1 ', (val1))

                        console.log('listaAll ', JSON.stringify(listAll))


                    } else if(item.length){
                        for (var i = 0; i < item.length; i++) {

                            ///////////////////if(texto.item[i]["georss:polygon"])
                            const val1 = item[i]["description"]._cdata

                            const val = item[i]["georss:polygon"]._text.split(' ').map(Number)
                            var list1 = []
                            var list2 = []
                            // var inde = 0;
                            //var index = Math.floor(i / 2);
                            for (var x = 0; x < val.length; x++) {
                                const valo = val[x];
                                //var index = i;
                                const index = Math.floor(x / 2);


                                if (list1[index] === undefined)
                                    list1[index] = [];
                                if (list2[index] === undefined)
                                    list2[index] = [];
                                list1[index].unshift(valo);
                                list2[index].push(valo)

                                console.log('list1 ', JSON.stringify(list2))

                            }
                            // console.log('item ', JSON.stringify(val["georss:polygon"]))
                            // console.log('item1 ', JSON.stringify(val["georss:polygon"]._text))
                            //if (listAll[i] === undefined)
                            // if (!Array.isArray(listAll[i]) || !listAll[i].length)
                            //listAll[i] = [];
                            if (pointInPolygon([coords.longitude, coords.latitude], list1)) {
                                //console.log('poly ', new Array(JSON.stringify(val["georss:polygon"]._text)))
                                // console.log('texto.item[i]',texto.item[i]["description"])
                                setAlerta(val1)
                                setShow(true)
                                listAll.unshift('<div class="alert alert-danger modal-header" style="display: inherit;">' + val1 + '</div>')
                                start()


                                //return  
                            } else {
                                console.log('val1 ', val1)

                                listAll.push(val1)
                            }

                            /*   if (list[inde] === undefined)
                                   list[inde] = [];*/
                            if (listMulti[i] === undefined)
                                //   if (!Array.isArray(listMulti[i]) || !listMulti[i].length)
                                listMulti[i] = [];

                            // list[inde].unshift(list1)
                            /*if (!Array.isArray(listMulti) || !listMulti.length)
                            if (!Array.isArray(listAll) || !listAll.length)*/

                            listMulti[i].push(list2)
                            // inde++;
                            //  console.log('lista ', JSON.stringify(list))
                            console.log('listaAll ', JSON.stringify(listAll))

                        }

                    }else{throw new Error("f a l l o en ")
                        return
                    }
                    setMultipoly(listMulti)
                    console.log('listallll', JSON.stringify(listAll))
                    // }
                    //   console.log('list ', JSON.stringify(list))
                    /* if (alerta) {
                         setShow(true)
                         //setMultipoly(listMulti)
                     } else {
                         setShow(false)
                         //setMultipoly(null)
                     }*/ //console.log(listMulti.length)
                    /* if(listMulti.length===1)
                     setPoly(listMulti[0])
                 else*/

                 setAllAlertas( listAll)//.replace('/</p/>,/<p/>', '/<hr/>')  </p>,<p>
                }/*).then(als =>

                    setAllAlertas(als)*/

                  

                )/*.then(lis=> {console.log("pointInPolygon ",pointInPolygon([coords.longitude, coords.latitude], lis))
            if(pointInPolygon([coords.longitude, coords.latitude], lis))
        setAlerta("A L E R T A") 
    else
    setAlerta("")
        })*/
                .catch((error) => {
                    console.error('ERROR axios xmldata:', error);
                    setErrorr("Actualmente hay problemas de conexión de datos con el SMN");
                })
        }, []);

    /*var timer = 0;
timer = setInterval(function(){ 
var currentdate = new Date();  
if(currentdate.getMinutes() % 1 == 0 && currentdate.getSeconds() == 30) {
    console.log("Alarm");
    setAllAlertas([[]])
}
}, 1000);
//to stop: clearInterval(timer);*/


    if (loading)
        return (
            <div>Cargando...</div>
        )
    else {
        return (<>

            {alerta &&
                <div className="container mb-2 text-center"> <div onClick={handleShow} style={{ cursor: 'pointer' }} className="alert alert-danger" dangerouslySetInnerHTML={{ __html: alerta }} />
                </div>
            }

            Latitud y longitud: {coords.latitude}, {coords.longitude}

            <Htmldia {...clima} />
            <Htmlhora {...clima} />
            <div className="container mt-2 text-center">

                {
                    multipoly.length ?
                        !errorr ?
                            <div onClick={handleShow} style={{ cursor: 'pointer' }} className="alert alert-danger">{allAlertas.length} Alerta{allAlertas.length > 1 && <span>s</span>} Meteorológica{allAlertas.length > 1 && <span>s</span>} del SMN</div>
                            :
                            <span style={{ color: 'red' }}>{errorr}</span>
                        :
                        <div onClick={(event) => { event.preventDefault(); window.open('https://www.smn.gob.ar/alertas', '_blank') }} style={{ cursor: 'pointer' }} className="alert alert-success">No hay Avisos a muy corto plazo del SMN</div>

                }

            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="alert alert-danger" closeButton>
                    <Modal.Title>{allAlertas.length} Alerta{allAlertas.length > 1 && <span>s</span>} Metereológica{allAlertas.length > 1 && <span>s</span>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <MapContainer style={{ height: "220px", width: "100%" }} center={[coords.latitude, coords.longitude]} zoom={4} scrollWheelZoom={false} id="map">
                        <TileLayer attribution='<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={[coords.latitude, coords.longitude]}>
                            {multipoly/*.length>1*/ && <Polygon pathOptions={redOptions} positions={multipoly} />}
                            <Popup>
                                Coordenadas <br /> {[coords.latitude + ", " + coords.longitude]}
                            </Popup>
                        </Marker>
                        <FullscreenControl />
                    </MapContainer>
                    <hr></hr>
                    <div dangerouslySetInnerHTML={{ __html: allAlertas.join("<hr>") }} />

                    {/*allAlertas ?
                <>
                    <div onClick={handleShow} style={{ cursor: 'pointer' }} className={alerta ? "alert alert-danger" : ""} dangerouslySetInnerHTML={{ __html: allAlertas }} />
                </> :<div>No se han emitido Avisos Meteorológicos a corto plazo en la REPUBLICA ARGENTINA</div>
        */}
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>

        </>)
    }
}
export default Main